
import { reactive, computed, watch, defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useTest } from '@/provider/test'

const answerIconText = {
  correct: '正解',
  incorrect: '不正解',
  no: '未回答'
}
const categories = [
  { label: '必修', value: '1' },
  { label: '一般', value: '2' },
  { label: '臨床', value: '3' }
]
export default defineComponent({
  name: 'ExamMasterList',
  props: {
    module: {
      type: Boolean,
      default: false
    },
    ignoreId: {
      type: Number,
      default: null
    },
    value: {
      type: String,
      default: '1'
    }
  },
  emits: ['input'],
  setup(props: any, context: any) {
    const route = useRoute()
    const page = computed(() => Number(route.query.page) || 1)
    const categoryId: any = route.params.categoryId
    const state = reactive({
      selectedCategory: categoryId || '1'
    })
    const { state: testState, getTests } = useTest()
    const limit = props.module ? 4 : 10
    const getBacknumbers = () => {
      getTests({
        limit,
        category: Number(state.selectedCategory),
        page: page.value
      })
    }
    const backnumbers = computed(() => {
      return props.module
        ? testState.tests
            .filter((d: any) => d.id !== props.ignoreId)
            .slice(0, 3)
        : testState.tests
    })

    const router = useRouter()
    watch(
      () => state.selectedCategory,
      () => {
        if (categoryId) {
          if (page.value === 1) getBacknumbers()
          router.push(`/magazines/exam/master/list/${state.selectedCategory}`)
        } else {
          getBacknumbers()
          context.emit('input', state.selectedCategory)
        }
      }
    )
    watch(() => page.value, getBacknumbers, { immediate: true })
    const setCategory = (category: string) => {
      state.selectedCategory = category
    }
    return {
      setCategory,
      state,
      answerIconText,
      categories,
      backnumbers
    }
  }
})
